import React, { useEffect } from 'react';
import DefaultLayout from '../../layout/DefaultLayout';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';

import { useCashCount } from '../../hooks/cash/useCashCount';

import CashAuditSummary from '../../components/CashCount/CashAuditSummary';
import CashCountDenominationSheet from '../../components/CashCount/CashCountDenominationSheet';
import CashCountSessionCard from '../../components/CashCount/CashCountSessionCard';
import CashCountObservations from '../../components/CashCount/CashCountObservations';

const CashCountPage: React.FC = () => {

  const {
    auditStarted,
    countNumber,
    expectedAmount,
    countedAmount,
    difference,
    observations,
    updateDenominations,
    updateObservation,
    getActive,
  } = useCashCount();

  useEffect(() => {
    getActive();
  }, []);

  return (

    <DefaultLayout>

      <BreadcrumbTwo />

      <div className="space-y-6">

        {/* 🔝 CARD SIEMPRE */}
        <CashCountSessionCard />

        {/* 🔥 SOLO SI AUDITORÍA INICIADA */}
        {auditStarted && (

          <div className="grid grid-cols-1 gap-6 xl:grid-cols-3">

            {/* IZQUIERDA */}
            <div className="xl:col-span-2">
              <CashCountDenominationSheet
                disabled={!auditStarted}
                auditStarted={auditStarted}
                onChange={updateDenominations}
              />
            </div>

            {/* DERECHA */}
            <div className="xl:col-span-1">
              <div className="sticky top-24 space-y-6">

                <CashAuditSummary
                  countNumber={countNumber}
                  expectedAmount={expectedAmount}
                  countedAmount={countedAmount}
                  difference={difference}
                />

                <CashCountObservations
                  value={observations}
                  onChange={updateObservation}
                  disabled={!auditStarted}
                />

              </div>
            </div>

          </div>

        )}

      </div>

    </DefaultLayout>

  );

};

export default CashCountPage;